



















import { mixins } from 'vue-class-component';
import { Component, Prop } from 'vue-property-decorator';
import FieldWrapper from '../field-wrapper/field-wrapper.vue';
import AbstractField from '../abstract-field/abstract-field';
import BpcFamilyListGroupInput from '@shared/components/forms/inputs/family-list-group-input/family-list-group-input.vue';
import BpcTeamListGroupInput from '@shared/components/forms/inputs/team-list-group-input/team-list-group-input.vue';
import { Contact } from '@contacts/interfaces/contact';

@Component({
  name: 'bpc-contact-relations-list-group-input',
  components: {
    BpcTeamListGroupInput,
    BpcFamilyListGroupInput,
    'bpc-field-wrapper': FieldWrapper,
  },
})
export default class ContactRelationsListGroupInput extends mixins(AbstractField) {
  @Prop(Array) declare readonly filters: any[];
  @Prop(String) readonly fieldForStorage: string;
  @Prop(Object) readonly formModel: Contact;

  get manageFrom() {
    return this.formModel?.type === 'individual' ? 'members' : 'teams';
  }

  get familyFilters() {
    return this.filters.concat({ filterField: 'family_contact_id', value: this.formModel.id });
  }

  get teamFilters() {
    return this.filters.concat({
      filterField: 'teams_groups_contact_id',
      value: this.formModel.id,
    });
  }
}
